export const ARTICLE_CONSTS = {
    GET_ARTICLES: "GET_ARTICLES",
    CREATE_ARTICLE: "CREATE_ARTICLE",
    GET_ARTICLE_BY_ID: "GET_ARTICLE_BY_ID",
    UPDATE_ARTICLE_BY_ID: "UPDATE_ARTICLE_BY_ID",
    DELETE_ARTICLE_BY_ID: "DELETE_ARTICLE_BY_ID",
};